import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';

export default class LeafBadge extends WritingBadge {
  public readonly id = BadgeId.leaf;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    return stats.wordsCount >= 100000;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/leaf.ts